export default {
  applyChangesButton: 'Zastosuj zmiany',
  buttonJumpToStart: 'Powrót do początku',
  buttonRewind: 'Przesuń się o {0} kroków ({1}) do tyłu',
  buttonPlay: 'Włącz',
  buttonPause: 'Pauza',
  buttonFastForward: 'Przejdź o {0} kroków ({1}) do przodu',
  buttonJumpToEnd: 'Przejdź do końca',
  buttonNextStep: 'Kolejny krok przepisu',
  buttonPrevStep: 'Poprzedni krok przepisu',
};
